import Picker from 'antd-mobile/lib/picker';
export default Picker;



// WEBPACK FOOTER //
// ./components/picker/index.tsx